import React from 'react'
import PropTypes from 'prop-types'
import MulticardColumn from '../../../components/MulticardColumn'
import {
  Container,
  ColumnsContainer,
} from '../StoreManagerOrStaff/index.screen'
import OrganizationsList from './OrganizationsList'

const OTAHomeScreen = ({ history, height }) => (
  <Container>
    <ColumnsContainer className="row no-gutters justify-content-md-center">
      <MulticardColumn
        height={height}
        minWidth={600}
        items={[
          {
            component: <OrganizationsList history={history} />,
          },
        ]}
      />
    </ColumnsContainer>
  </Container>
)

OTAHomeScreen.propTypes = {
  height: PropTypes.number,
  history: PropTypes.object.isRequired,
}

export default OTAHomeScreen
